// German for the obligation ladder — the rung titles, the fallback sentences, the route and
// primary labels, and RUNG_NOUN. The server's own blocker sentences are quoted unedited (B7)
// and are not in this catalogue.
import { registerDe } from '../../i18n/index.js';

registerDe({
  // RUNG_NOUN
  'held': 'übernommen',
  'the review queue': 'die Warteschlange',
  'funded': 'finanziert',
  'justified': 'begründet',
  'proven': 'geprüft',

  // 1 · held
  'Every requirement held': 'Jede Anforderung übernommen',
  'The register is empty — nothing is on record to confirm.': 'Das Register ist leer — es gibt nichts zu bestätigen.',
  '{held} of {total} requirements held': '{held} von {total} Anforderungen übernommen',
  'the {n} row still proposed': 'die {n} noch vorgeschlagene Zeile',
  'the {n} rows still proposed': 'die {n} noch vorgeschlagenen Zeilen',
  'All rows': 'Alle Zeilen',
  'Confirm {n} proposed': '{n} vorgeschlagene bestätigen',

  // 2 · queue
  'Zero pending proposals': 'Keine ausstehenden Vorschläge',
  'The review queue is clear.': 'Die Warteschlange ist leer.',
  '{n} proposal awaiting review': '{n} Vorschlag wartet auf Prüfung',
  '{n} proposals awaiting review': '{n} Vorschläge warten auf Prüfung',
  'Proposals': 'Vorschläge',
  'Review {n} proposal': '{n} Vorschlag prüfen',
  'Review {n} proposals': '{n} Vorschläge prüfen',

  // 3 · funded
  'Every MUST requirement maps to a deliverable': 'Jede Muss-Anforderung ist einem Arbeitsergebnis zugeordnet',
  'No MUST requirement is on the register — the gate wants at least one.': 'Keine MUSS-Anforderung im Register — das Gate verlangt mindestens eine.',
  '{mapped} of {total} MUST requirements mapped': '{mapped} von {total} MUSS-Anforderungen zugeordnet',
  'the unfunded musts': 'die nicht finanzierten Muss-Anforderungen',
  'Map the unfunded musts': 'Nicht finanzierte Muss-Anforderungen zuordnen',

  // 4 · justified
  'No deliverable without a requirement': 'Kein Arbeitsergebnis ohne Anforderung',
  'No deliverable is defined — there is nothing for a requirement to map to.': 'Kein Arbeitsergebnis definiert — eine Anforderung kann nirgends zugeordnet werden.',
  '{n} of {total} deliverables carry at least one requirement': '{n} von {total} Arbeitsergebnissen tragen mindestens eine Anforderung',
  'Deliverables': 'Arbeitsergebnisse',
  'Open the deliverables': 'Arbeitsergebnisse öffnen',

  // 5 · proven
  'Every acceptance criterion has a test case': 'Jedes Abnahmekriterium hat einen Testfall',
  'No acceptance criterion is on record yet — nothing here is testable.': 'Noch kein Abnahmekriterium erfasst — hier ist nichts prüfbar.',
  '{n} of {total} criteria have a test case': '{n} von {total} Kriterien haben einen Testfall',
  'Test cases': 'Testfälle',
  'Propose test cases for {n} criterion': 'Testfälle für {n} Kriterium vorschlagen',
  'Propose test cases for {n} criteria': 'Testfälle für {n} Kriterien vorschlagen',
}, 'ladder');
